/**
 * 
 * 提交订单数据存储
 */
let initState = {
  vipInfo: [],
  position: ''
}
const submitOrderInfo = {
    state: {
      vipInfo: [], //尊享服务勾选的信息
      position: '' //定位坐标
    },
    mutations: {
      setVipInfo: (state, data) => {
        state.vipInfo = data
      },
      addVipInfo: (state, data) => {
        state.vipInfo.forEach((value)=>{
          if(value.productCode == data.productCode){
            let flag = 0;
            if(value.addedService.length == 0){
              value.addedService.push(data.addedService);
            }else{
              value.addedService.forEach((cont,index)=>{
                if(cont.name == data.addedService.name){
                  cont.num += data.addedService.num;
                  cont.total += parseInt(data.addedService.total);
                  cont.unitPrice += parseInt(data.addedService.unitPrice);
                  flag = 1;
                }
                if(index == value.addedService.length-1 && flag == 0){
                  value.addedService.push(data.addedService);
                }
              })
            }
          }
        })
      },
      updateVipInfo: (state, data) => {},
      addPolicy: (state, data) => {
        state.vipInfo.forEach((value)=>{
          if(value.productCode == data.productCode){
            value.policy = data.personList;
          }
        })
      },
      addPosition: (state, data) => {
        state.position = data
      },
      resetSubmitOrderInfo (state) {
        Object.keys(state).forEach(key => { state[key] = initState[key]})
      },
    },
    actions: {

    }
}

export default submitOrderInfo



// WEBPACK FOOTER //
// ./src/store/submitOrderInfo.js